const calculateFontSize = ({ fontFamily, text, paddedWidth, multiplier = 1 }) => {
  const textCalcResult = [];

  text.forEach((item) => {
    let size = 0;
    const resizer = document.createElement('SPAN');
    resizer.style.fontFamily = fontFamily;
    resizer.style.fontSize = `${size}px`;
    resizer.style.visibility = 'hidden';
    resizer.style.position = 'absolute';

    document.body.appendChild(resizer);
    resizer.innerHTML = item;

    // ignore this for testing because we cannot calculate this offsetWidth correctly to compare
    /* istanbul ignore next */
    while (resizer.offsetWidth < paddedWidth) {
      size += 1;
      resizer.style.fontSize = `${size}px`;
    }
    document.body.removeChild(resizer);
    textCalcResult.push((size - 2) * multiplier);
  });

  return Math.min(...textCalcResult);
};

export default calculateFontSize;
